export default __webpack_public_path__ + "static/media/googleDriveIcon.2d53f651.svg";